import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetLinks } from "../Widgets/WidgetLinks";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";

export type WidgetLinksComponentProps = {
    widget: WidgetLinks;
    title: LanguageString;
}

export class WidgetLinksComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetLinksComponentProps;

    constructor(props: WidgetLinksComponentProps) {
        super(props);
    }


    private getClickableLink = (link: string): string => {
        return link.startsWith("http://") || link.startsWith("https://") ?
            link
            : `http://${link}`;
    };

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                <div className="container overflow-auto">
                    {this.renderLinksList()}
                </div>
            </div>
        </div>;

    public renderLinksList(): HTMLElement {
        let data = this.props.widget.getLinksData();
        let ulElement: HTMLElement = <ul className="list-group list-group-flush"></ul>;
        for (let item in data) {
            let liElement: HTMLElement = <li className="list-group-item d-flex align-items-center px-3 py-1"></li>;
            let linkChildElem: HTMLElement = <a className="flex-shrink-0">{data[item].name}</a>;
            linkChildElem.setAttribute("href", this.getClickableLink(data[item].url));
            linkChildElem.setAttribute("target", "_blank");
            liElement.appendChild(<i className="fal fa-link flex-shrink-0 mr-2"></i>)
            liElement.appendChild(linkChildElem);
            ulElement.appendChild(liElement);
        }

        return ulElement;
    }

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        return this.element;
    }
}